export const moduleName = 'countries'
